<template>
  <div class="modal-mask quote-signature-modal-mask" v-if="visible" @click.self="$emit('cancel')">
    <div class="modal-wrapper">
      <div class="modal-container small quote-signature-modal-container" @click.stop>
        <div class="modal-header">
          <i class="close icon" v-on:click="$emit('cancel')"></i>
          <h3>{{ title }}</h3>
        </div>
        <div class="ui divider"></div>
        <div class="modal-body quote-signature-modal-body">
          <form class="ui form">
            <div class="field settings" v-if="showOptionSelect">
              <label>Selected Option<span class="required-asterisk">*</span></label>
              <app-select
                :items="optionSelectItems"
                :value="selectedOptionId"
                @selected="onOptionSelected">
              </app-select>
            </div>
            <div class="field settings">
              <label>{{ nameLabel }}<span class="required-asterisk">*</span></label>
              <input type="text" :value="customerName" @input="$emit('update:customerName', $event.target.value)" :placeholder="namePlaceholder">
            </div>
            <div class="field settings">
              <label>{{ signatureLabel }}<span class="required-asterisk">*</span></label>
              <signature-pad
                ref="signaturePad"
                @update:model-value="$emit('update:signatureData', $event)"
                @ink-change="$emit('update:hasSignature', $event)">
              </signature-pad>
            </div>
            <p class="quote-signature-disclaimer">{{ disclaimer }}</p>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="ui basic button smardie-btn-secondary" @click="$emit('cancel')">Cancel</button>
          <button
            type="button"
            class="ui primary button"
            :class="{ loading: submitting, disabled: submitting || !canSubmit }"
            :disabled="submitting || !canSubmit"
            @click="$emit('submit')">
            {{ submitLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SignaturePad from '../quote/modals/preview/SignaturePad.vue'

export default {
  name: 'SignatureAcceptModal',
  components: { SignaturePad },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: 'Signature Required' },
    nameLabel: { type: String, default: 'Customer Name' },
    signatureLabel: { type: String, default: 'Signature' },
    namePlaceholder: { type: String, default: 'Enter customer name' },
    customerName: { type: String, default: '' },
    disclaimer: { type: String, default: '' },
    canSubmit: { type: Boolean, default: false },
    submitting: { type: Boolean, default: false },
    submitLabel: { type: String, default: 'Agree and Submit' },
    optionSelectItems: { type: Array, default: function () { return [] } },
    selectedOptionId: { type: [Number, String], default: null }
  },
  computed: {
    showOptionSelect () {
      return Array.isArray(this.optionSelectItems) && this.optionSelectItems.length > 1
    }
  },
  methods: {
    onOptionSelected (payload) {
      const id = payload && payload.id != null ? payload.id : null
      this.$emit('update:selectedOptionId', id)
    },
    prime () {
      this.$nextTick(() => {
        this.$nextTick(() => {
          if (this.$refs.signaturePad && typeof this.$refs.signaturePad.prime === 'function') {
            this.$refs.signaturePad.prime()
          }
        })
      })
    }
  }
}
</script>
